module.exports = __webpack_public_path__ + "static/media/Harsh_Vador_192x192.3af3cd97.jpg";